import React, { useState } from 'react'
import '../styles/compsStyles/postEditModal.css'

const PostEditModal = ({ post, onClose, onSave }) => {
  const [title, setTitle] = useState(post.title || '')
  const [tags, setTags] = useState(post.tages || '')
  const [description, setDescription] = useState(post.description || '')
  const [error, setError] = useState('')
  const [saving, setSaving] = useState(false)

  const save = async () => {
    if (title.trim().length < 3 || description.trim().length < 3) {
      setError('Title and description need at least 3 characters.')
      return
    }
    setSaving(true)
    setError('')
    try {
      await onSave({
        ...post,
        title: title.trim(),
        tages: tags.trim() || post.tages,
        description: description.trim()
      })
    } catch (err) {
      setError(err.message || 'Could not save this post.')
      setSaving(false)
    }
  }

  return (
    <div className="postEditOverlay" onClick={onClose} role="presentation">
      <div className="postEditCard" onClick={(e) => e.stopPropagation()} role="dialog" aria-labelledby="postEditTitle">
        <h2 id="postEditTitle">Edit post</h2>
        <label>
          <span>Title</span>
          <input value={title} maxLength={60} onChange={(e) => setTitle(e.target.value)} />
        </label>
        <label>
          <span>Tags</span>
          <input value={tags} maxLength={100} onChange={(e) => setTags(e.target.value)} />
        </label>
        <label>
          <span>Description</span>
          <textarea value={description} maxLength={1000} rows={4} onChange={(e) => setDescription(e.target.value)} />
        </label>
        {error && <p className="postEditError">{error}</p>}
        <div className="postEditActions">
          <button type="button" onClick={onClose}>Cancel</button>
          <button type="button" className="postEditSave" onClick={save} disabled={saving}>
            {saving ? 'Saving…' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default PostEditModal
